module.exports = __webpack_public_path__ + "img/by.80b2d2dd.svg";